import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [logoutReason, setLogoutReason] = useState(null);

  useEffect(() => {
    const reason = sessionStorage.getItem('logout_reason');
    if (reason) {
      setLogoutReason(reason);
      sessionStorage.removeItem('logout_reason');
    }
  }, [user]);

  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center gap-3">
        <Loader2 className="w-6 h-6 animate-spin text-cyan-400" />
        <span className="text-zinc-400 text-sm font-mono">Authenticating...</span>
      </div>
    );
  }

  if (!user) {
    // Build redirect state with session expired info
    const state = { from: location.pathname };
    if (logoutReason === 'session_expired' || logoutReason === 'idle_timeout') {
      state.sessionExpired = true;
      state.reason = logoutReason === 'idle_timeout'
        ? 'Your session timed out due to inactivity.'
        : 'Your session has expired. Please log in again.';
    }
    return <Navigate to="/login" replace state={state} />;
  }

  return children;
};

export default ProtectedRoute;
